import ContainerSimple from "../../../Components/ContainerSimple"
import InputAdmin from "../../../Components/InputFields/InputAdmin"
import Custom from "../../../Components/Buttons/Custom"
import { useState } from "react"

export default function EditAdminContainer({}) {

  return (
    <ContainerSimple>
      <div className="w-full flex gap-12">
        <InputAdmin label="نقش مدیریتی" id="type" name="type" type="select" selectOptions={["ادمین پشتیبانی", "ادمین مالی"]} selectPlaceHolder="انتخاب کنید"/>
        <InputAdmin label="وضعیت حساب" id="type" name="type" type="select" selectOptions={["فعال", "غیر فعال"]} selectPlaceHolder="انتخاب کنید"/>
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin label="نام" id="type" name="type" type="text"/>
        <InputAdmin label="نام خانوادگی" id="type" name="type" type="text"/>
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin label="آدرس ایمیل" id="type" name="type" type="email"/>
        <InputAdmin label="شماره تلفن همراه" id="type" name="type" type="tel"/>
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin label="تصویر حساب" id="type" name="type" type="file"/>
        <div className="w-full"></div>
      </div>
      <div className="w-full flex gap-2.5 mt-6">
        <Custom text="انصراف و بستن" svg_name="xMark" svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark" href="" className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark bg-transparent"
        onClick={() => window.location.href = "/admins"}
        />
        <Custom text="ایجاد ادمین جدید" svg_name="checkMark" svgClassName="stroke-zi-text-dark" href="" className="!rounded-lg !p-2.5 w-full text-zi-text-dark bg-zi-gradient-button-blue" textShadow={true} svgShadow={true}
        onClick={() => window.location.href = "/admins"}
        />
      </div>
    </ContainerSimple>
  )
}